export default __webpack_public_path__ + "static/media/Voyageur 04.6d55e2c2.png";